/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Button } from '@radix-ui/themes';

import { use, useCallback } from 'fierry/react';

import Navigation from 'solis/navigation';
import Routes from 'solis/enum/route';


const OnClick = (event, dispatch, boardID) =>
{
  dispatch.pushForeground({ route: Routes.DashboardBoard.replace(':id', boardID) });
};


const Component = ({ boardID }) =>
{
  const dispatch = use(Navigation.Dispatch);

  const onClick = useCallback(OnClick, [ dispatch, boardID ]);

  return <Button onClick = {onClick}>View Board</Button>;
};


export default ({ colony }) =>
{
  return colony.cass.board ? <Component boardID = {colony.cass.board} /> : null;
};
